import React, { useState } from "react";

const ContactForm = () => {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(null);
  const [fields, setFields] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFields({ ...fields, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setSent(null);
    try {
      const res = await fetch("https://appapi.unpaidfinancial.com/api/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(fields),
      });
      if (res.ok) {
        setSent(true);
        setFields({ name: "", email: "", subject: "", message: "" });
      } else {
        setSent(false);
      }
    } catch {
      setSent(false);
    }
    setSending(false);
  };

  const styles = {
    section: {
      marginTop: "50px",
      minHeight: "100vh",
      width: "100%",
      background: "#1e293b", // bluegray-800
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "40px 8px",
    },
    container: {
      maxWidth: 540,
      width: "100%",
      background: "#e2e8f0", // bluegray-400
      borderRadius: 12,
      boxShadow: "0 8px 32px rgba(0,0,0,0.10)",
      padding: "38px 30px 28px 30px",
      textAlign: "left",
      color: "#1e293b", // bluegray-800
    },
    input: {
      width: "100%",
      padding: "11px 15px",
      marginBottom: 18,
      border: "1.5px solid #cbd5e1",
      borderRadius: 7,
      fontSize: 17,
      fontFamily: "inherit",
      background: "#f1f5f9", // gris très clair pour le contraste
      color: "#1e293b",
      outline: "none",
    },
    textarea: {
      width: "100%",
      padding: "11px 15px",
      minHeight: 100,
      border: "1.5px solid #cbd5e1",
      borderRadius: 7,
      fontSize: 17,
      fontFamily: "inherit",
      resize: "vertical",
      marginBottom: 18,
      background: "#f1f5f9",
      color: "#1e293b",
      outline: "none",
    },
    button: {
      background: "#1e293b", // bluegray-400
      color: "#fff", // bluegray-800
      fontWeight: 600,
      fontSize: 17,
      border: "none",
      borderRadius: 7,
      padding: "11px 30px",
      cursor: "pointer",
      transition: "background 0.15s",
      boxShadow: "0 1px 4px rgba(0,0,0,0.05)",
    },
    success: {
      background: "#22c55e",
      color: "#fff",
      borderRadius: 7,
      padding: "9px 15px",
      marginBottom: 14,
      textAlign: "center"
    },
    error: {
      background: "#ef4444",
      color: "#fff",
      borderRadius: 7,
      padding: "9px 15px",
      marginBottom: 14,
      textAlign: "center"
    },
    social: {
      display: "flex",
      justifyContent: "center",
      gap: "24px",
      marginTop: 32
    },
    icon: {
      fontSize: 35,
      color: "#1e293b", // bluegray-800
      transition: "color 0.17s",
      textDecoration: "none"
    }
  };

  return (
    <section style={styles.section}>
    <div style={styles.container}>
      <h2 style={{ fontWeight: 700, marginBottom: 22, textAlign: "center", color: "#1e293b" }}>
        Contactez-nous
      </h2>
      {sent === true && <div style={styles.success}>Message envoyé avec succès !</div>}
      {sent === false && <div style={styles.error}>Erreur lors de l'envoi. Réessayez.</div>}
      <form onSubmit={handleSubmit} autoComplete="off">
        <input
          type="text"
          name="name"
          placeholder="Votre nom"
          required
          style={styles.input}
          value={fields.name}
          onChange={handleChange}
        />
        <input
          type="email"
          name="email"
          placeholder="Votre email"
          required
          style={styles.input}
          value={fields.email}
          onChange={handleChange}
        />
        <input
          type="text"
          name="subject"
          placeholder="Sujet"
          required
          style={styles.input}
          value={fields.subject}
          onChange={handleChange}
        />
        <textarea
          name="message"
          placeholder="Votre message"
          required
          style={styles.textarea}
          value={fields.message}
          onChange={handleChange}
        />
        <div style={{ textAlign: "center" }}>
          <button type="submit" style={styles.button} disabled={sending}>
            {sending ? "Envoi en cours..." : "Envoyer"}
          </button>
        </div>
      </form>
      {/* Réseaux sociaux */}
      <div style={styles.social}>
        <a
          href="https://wa.me/+33774137802"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.icon}
          title="WhatsApp"
        >
          <i className="fab fa-whatsapp"></i>
        </a>
        <a
          href="https://www.facebook.com/share/19BSqUewPQ/?mibextid=wwXIfr"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.icon}
          title="Facebook"
        >
          <i className="fab fa-facebook"></i>
        </a>
      </div>
    </div>
  </section>
);
};

export default ContactForm;
